import * as React from "react"

export const PlaceholderWorkspace = (): JSX.Element => {
    return (
        <li
            className="tw-my-1 tw-py-1 tw-px-3 theme-bubble bg-nickel"
            style={{ height: "39px" }}
        ></li>
    )
}

export default PlaceholderWorkspace
